<template>
  <div class="box-tab">
    <div id="accordion">
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES85UC3']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="detail-block">

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['20'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['30'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="place" name="place">{{ detail.tab1.place }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['40'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="desc_codcnty" name="desc_codcnty">{{ detail.tab1.desc_codcnty }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['50'] }}</div>
                  <div class="detail-right">
                      <div class="input-group width-70">
                          <input type="text" disabled="disabled" class="form-control input-text" id="distance" name="distance" v-model="detail.tab1.distance" />
                          <div class="input-group-addon input-group-addon-cust">{{ labels['HRES85UC3']['60']}}</div>
                      </div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['70'] }}</div>
                  <div class="detail-right">
                      <div class="input-group width-70">
                          <input type="text" disabled="disabled" class="form-control input-text" id="costkms" name="costkms" v-model="detail.tab1.costkms" />
                          <div class="input-group-addon input-group-addon-cust">{{ labels['HRES85UC3']['80'] }}</div>
                      </div>
                      <div class="text-error" id="form-errors-p_amtwidrw"></div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['190'] }}</div>
                  <div class="detail-right">
                      <div class="input-group width-70">
                          <input type="text" disabled="disabled" class="form-control input-text" id="costday" name="costday" v-model="detail.tab1.costday" />
                          <div class="input-group-addon input-group-addon-cust">{{ labels['HRES85UC3']['200'] }}</div>
                      </div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['90'] }}</div>
                  <div class="detail-right">
                      <textarea class="detail-text width-70" id="remark" name="remark" disabled="disabled">{{ detail.tab1.remark }}</textarea>
                  </div>
                </div>
              </div>

              <div class="detail-block-float detail-block-left">
                <div class="detail-header">{{ labels['HRES85UC3']['100'] }}</div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['110'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="dtestrt" name="dtestrt">{{ setDateOutput(detail.tab1.dtestrt) }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['120'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="timstrt" name="timstrt">{{ detail.tab1.timstrt }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['130'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="dteend" name="dteend">{{ setDateOutput(detail.tab1.dteend) }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['140'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="timend" name="timend">{{ detail.tab1.timend }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['150'] }}</div>
                  <div class="detail-right">
                    <div class="input-group width-70">
                      <input type="text" disabled="disabled" class="form-control input-text" id="qtyday" name="qtyday" v-model="detail.tab1.qtyday" />
                      <div class="input-group-addon input-group-addon-cust">{{ labels['HRES85UC3']['160'] }}</div>
                    </div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['170'] }}</div>
                  <div class="detail-right">
                    <div class="input-group width-70">
                      <input type="text" disabled="disabled" class="form-control input-text" id="amtreq" name="amtreq" v-model="detail.tab1.amtreq" />
                      <div class="input-group-addon input-group-addon-cust">{{ labels['HRES85UC3']['180'] }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="detail-block-float detail-block-right">
                <div class="detail-header">{{ labels['HRES85UC3']['210'] }}</div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['220'] }}</div>
                  <div class="detail-right">
                    <div class="detail-text width-70">
                      <!-- <a :href="detail.tab1.path_filenam1" target="_blank">{{ detail.tab1.filenam1 }}</a> -->
                      <a :href="baseURL + detail.tab1.path_filenam1" target="_blank">{{ detail.tab1.filenam1 }}</a>
                    </div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['230'] }}</div>
                  <div class="detail-right">
                    <div class="detail-text width-70">
                      <!-- <a :href="detail.tab1.path_filenam2" target="_blank">{{ detail.tab1.filenam2 }}</a> -->
                      <a :href="baseURL + detail.tab1.path_filenam2" target="_blank">{{ detail.tab1.filenam2 }}</a>
                    </div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['240'] }}</div>
                  <div class="detail-right">
                    <div class="detail-text width-70">
                      <!-- <a :href="detail.tab1.path_filenam3" target="_blank">{{ detail.tab1.filenam3 }}</a> -->
                      <a :href="baseURL + detail.tab1.path_filenam3" target="_blank">{{ detail.tab1.filenam3 }}</a>
                    </div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES85UC3']['250'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text txtarea-width width-70" id="descnote" name="descnote">{{ detail.tab1.descnote }}</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES85UC6']['0'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">

            <hrms-table :columns="tab2Table" :data="detail.tab2.table" />

          </div>
        </div>
      </div>

    </div>

    <div class="box-footer">
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
    </div>

  </div>
</template>

<script>
import env from 'src/../env.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres85u-detail',
  props: [ 'labels', 'labelsButton', 'detail', 'toggle', 'data', 'nowLang', 'tab2Table' ],
  data () {
    return {
      baseURL: window.localStorage.getItem(env.site + '_baseURL') + 'file_uploads/'
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?008fc088